import type { DraftEmailConfig } from "@services/demo/msoffice/types";
import type { EmailMessage } from "@services/documents/email/types";
import type { MsofficeApiClient, MsofficeApiFunctions } from "./types";

export function createMsofficeApi(apiClient: MsofficeApiClient): MsofficeApiFunctions {
  return {
    draftMessage: (config: DraftEmailConfig) =>
      apiClient.post<{ status: string }>("/msoffice-api/demo/outlook/draft_message", config),

    getEmailWithAttachments: (emailId: string) =>
      apiClient.get<EmailMessage>(
        `/documents/email/stored/email_with_attachments/${encodeURIComponent(emailId)}`
      ),
  };
}
